export const showLog = ({message, obj}) => {
    try {
        if (process.env.REACT_APP_LOGS) {
            console.log(message, obj);
        }
    } catch (error) {
        throw error;
    }
}